import { BaseExcelColor, ExcelColor } from './excelColor';

export type TableStyle = {
  headerColor: BaseExcelColor;
  primaryColor: BaseExcelColor;
  secondaryColor: BaseExcelColor;
  stretchToFit: boolean;
};

export const DEFAULT_TABLE_STYLE: TableStyle = {
  headerColor: ExcelColor.fromHex('#818cf8'),
  primaryColor: ExcelColor.fromHex('#eff6ff'),
  secondaryColor: ExcelColor.fromHex('#dbeafe'),
  stretchToFit: false,
};
